/* eslint-disable @typescript-eslint/no-require-imports */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ILobasDocumentListConfig } from '../modules/lobas-document-list/lobas-document-list.props.autogenerated';

/**
 * GetAllFtpDocuments Input Action
 */
export class GetFtpDocumentsInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public config: ILobasDocumentListConfig;

    constructor(config: ILobasDocumentListConfig) {
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () =>
        `IGetFtpDocumentsData_${this.config.ftpServerPath}_${
            this.config.documentSearchKeywords ? this.config.documentSearchKeywords.join('_') : ''
        }`;
    public getCacheObjectType = () => 'IGetFtpDocumentsData';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

export declare enum FileType {
    Unknown = 0,
    File = 1,
    Directory = 2,
    SymbolicLink = 3
}
export interface UnixPermissions {
    readonly user: number;
    readonly group: number;
    readonly world: number;
}
// TODO: Create a data model here or import one to capture the response of the action
export interface IGetFtpDocumentsData {
    name: string;
    type: FileType;
    size: number;
    rawModifiedAt: string;
    modifiedAt?: Date;
    permissions?: UnixPermissions;
    hardLinkCount?: number;
    link?: string;
    group?: string;
    user?: string;
    uniqueID?: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetFtpDocumentsInput(args.config as ILobasDocumentListConfig);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetFtpDocumentsInput, ctx: Msdyn365.IActionContext): Promise<IGetFtpDocumentsData[]> {
    const ftp = require('basic-ftp');
    let fileList: IGetFtpDocumentsData[] = [];

    const ftpConfig = {
        host: input.config.ftpServerHost,
        port: input.config.ftpServerPort,
        user: input.config.ftpServerUser,
        password: input.config.ftpServerPassword,
        secure: false
    };

    const client = new ftp.Client();

    try {
        await client.access(ftpConfig);
        //console.log(input.config.ftpServerPath);
        fileList = await client.list(`${input.config.ftpServerRootPath}${input.config.ftpServerPath}`);
        //console.log(fileList[0]);
    } catch (err) {
        //console.log(err);
    } finally {
        client.close();
    }

    return fileList;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetFtpDocumentsData[]>>action,
    id: 'GetFtpDocuments',
    input: createInput
});
